module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"changePassword":"Change Password 🔒","changePasswordMessage":"Please enter your new password","submit":"Submit"},"al":{"changePassword":"Ndrysho Fjalëkalimin 🔒","changePasswordMessage":"Ju lutemi futni fjalëkalimin e ri ","submit":"Konfirmo"}}')
  delete Component.options._Ctor
}
